import React from "react";
import { DatePicker, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import * as dayjs from "dayjs";

const { Option } = Select;

const CrmTaskFields = ({
  title,
  onTitleChange,
  dueAt,
  onDueAtChange,
  assigneeUid,
  onAssigneeUidChange,
  cmsUsers,
  defaultAssigneeUid,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <Input value={title} onChange={(e) => onTitleChange(e.target.value)} placeholder={t("task")} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format="DD-MM-YYYY HH:mm"
          value={dueAt ? dayjs(dueAt) : null}
          onChange={(val) => onDueAtChange(val ? val.toDate() : null)}
          placeholder={t("due_date")}
          style={{ width: "100%" }}
        />
      </div>
      <Select
        value={assigneeUid || defaultAssigneeUid}
        onChange={onAssigneeUidChange}
        placeholder={t("assigned_to")}
        style={{ width: "100%" }}
        optionFilterProp="children"
        showSearch
      >
        {(cmsUsers || []).map((u) => (
          <Option key={u.id} value={u.id}>
            {u.email}
          </Option>
        ))}
      </Select>
    </>
  );
};

export default CrmTaskFields;
